import { forwardRef } from "react";

// Visually hidden honeypot input. Real users won't fill it; bots often will.
// If submitted with a value, the backend silently drops the submission.
export const HoneypotField = forwardRef<HTMLInputElement, { value: string; onChange: (v: string) => void }>(
  ({ value, onChange }, ref) => (
    <div
      aria-hidden="true"
      style={{
        position: "absolute",
        left: "-10000px",
        top: "auto",
        width: "1px",
        height: "1px",
        overflow: "hidden",
      }}
    >
      <label>
        Website (leave blank)
        <input
          ref={ref}
          type="text"
          name="website"
          tabIndex={-1}
          autoComplete="off"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      </label>
    </div>
  ),
);
HoneypotField.displayName = "HoneypotField";